module.exports = __webpack_public_path__ + "img/4.6a7fccf5.jpg";